export function createRoutes() {
  return [
    {
      path: 'pages-designer',
      component: () => import(/* webpackChunkName: "PageDesigner" */ './PageDesignerChrome.vue'),
      children: [
        {
          path: '/',
          component: () => import(/* webpackChunkName: "PageDesignerList" */ './PageDesignerList.vue'),
        },
        {
          path: ':pageDesignerKey',
          name: 'pageDesignerDetail',
          component: () => import(/* webpackChunkName: "PageDesignerDetail" */ './PageDesignerDetail.vue'),
        },
        {
          path: ':pageDesignerKey/components/:pageComponentKey',
          component: () => import(/* webpackChunkName: "PageComponentChrome" */ './PageComponentChrome.vue'),
          children: [
            {
              path: '/',
              name: 'pageComponent',
              component: () => import(/* webpackChunkName: "PageComponent" */ './PageComponent.vue'),
            },
          ],
        },
        {
          path: ':pageDesignerKey/editgrid/:gridId',
          component: () => import(/* webpackChunkName: "PageDesignerDetail" */ './grid/GridEditor.vue'),
        },
      ],
    },
    {
      path: 'popup',
      component: () => import(/* webpackChunkName: "PopupEditor" */ './popup/PopupEditor.vue'),
    },
  ];
}

export default {
  createRoutes,
};
